import { render, staticRenderFns } from "./DialogCobranca.vue?vue&type=template&id=25d84b10"
import script from "./DialogCobranca.vue?vue&type=script&lang=js"
export * from "./DialogCobranca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports